import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { z } from 'zod'

export const schema = z.object({
  historyPage: z.number().int().nonnegative().optional(),
  historySize: z.number().int().nonnegative().optional(),
  uploadedFilesPage: z.number().int().nonnegative().optional(),
  uploadedFilesSize: z.number().int().nonnegative().optional(),
  uploadedFilesSortBy: z.number().int().nonnegative().optional(),
  uploadedFilesSortDesc: z.boolean().optional()
})

export const HighRiskDetailsRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: `$id`,
    component: lazyRouteComponent(() => import('./Details')),
    validateSearch: (search) => schema.parse(search),
    loaderDeps: ({ search }) => ({
      search
    })
  })
